import { DateTime } from 'luxon'

export default {
  computed: {
    startOfThisWeek() {
      return DateTime.local().startOf('week').toFormat('yyyy-MM-dd')
    },

    endOfThisWeek() {
      return DateTime.local().endOf('week').toFormat('yyyy-MM-dd')
    },

    startOfThisMonth() {
      return DateTime.local().startOf('month').toFormat('yyyy-MM-dd')
    },

    endOfThisMonth() {
      return DateTime.local().endOf('month').toFormat('yyyy-MM-dd')
    },

    startOfThisYear() {
      return DateTime.local().startOf('year').toFormat('yyyy-MM-dd')
    },

    endOfThisYear() {
      return DateTime.local().endOf('year').toFormat('yyyy-MM-dd')
    },

    yesterday() {
      return DateTime.local().startOf('day').minus({ days: 1 }).toFormat('yyyy-MM-dd')
    },

    startOfLastMonth() {
      return DateTime.local().startOf('month').minus({ months: 1 }).toFormat('yyyy-MM-dd')
    },

    endOfLastMonth() {
      return DateTime.local().endOf('month').minus({ months: 1 }).toFormat('yyyy-MM-dd')
    },

    startOfThisFiscalYear() {
      const now = DateTime.local()

      // From this year to next year
      if (now.get('month') > 9) {
        return DateTime.local().set({ month: 10 }).startOf('month').toFormat('yyyy-MM-dd')
      }

      return DateTime.local().minus({ year: 1 }).set({ month: 10 }).startOf('month')
        .toFormat('yyyy-MM-dd')
    },

    endOfThisFiscalYear() {
      const now = DateTime.local()

      // Ends in next year
      if (now.get('month') > 9) {
        return DateTime.local().plus({ year: 1 }).set({ month: 9 }).endOf('month')
          .toFormat('yyyy-MM-dd')
      }

      return DateTime.local().set({ month: 9 }).endOf('month').toFormat('yyyy-MM-dd')
    },

    startOfLastFiscalYear() {
      const now = DateTime.local()

      if (now.get('month') > 9) {
        return DateTime.local().minus({ year: 3 }).set({ month: 10 }).startOf('month')
          .toFormat('yyyy-MM-dd')
      }

      return DateTime.local().minus({ year: 2 }).set({ month: 10 }).startOf('month')
        .toFormat('yyyy-MM-dd')
    },

    endOfLastFiscalYear() {
      const now = DateTime.local()

      if (now.get('month') > 9) {
        return DateTime.local().set({ month: 9 }).endOf('month')
          .toFormat('yyyy-MM-dd')
      }

      return DateTime.local().minus({ year: 1 }).set({ month: 9 }).endOf('month')
        .toFormat('yyyy-MM-dd')
    },

    thisMonth() {
      return DateTime.local().toFormat('yyyy-MM')
    },

    today() {
      return DateTime.local().toFormat('yyyy-MM-dd')
    }
  }
}
